import { useSupport } from '../../../../../../context/support/SupportContext';
import ChatHeader from './sections/ChatHeader';
import MessageStream from './sections/MessageStream';
import MessageInput from './sections/MessageInput';
import EmptyChatView from './sections/EmptyChatView';

const ChatConsole = () => {
  const { selectedChatBookingId, chatThread } = useSupport();

  return (
    <div
      className={`flex-1 min-w-0 flex flex-col bg-white overflow-hidden ${
        selectedChatBookingId ? 'flex' : 'hidden md:flex'
      }`}
    >
      {selectedChatBookingId ? (
        chatThread ? (
          <div className="flex-1 flex flex-col overflow-hidden">
            <ChatHeader />
            <MessageStream />
            <MessageInput />
          </div>
        ) : (
          <div className="flex-1 flex flex-col items-center justify-center p-12 text-center space-y-3">
            <div className="animate-spin h-8 w-8 border-3 border-[#067978] border-t-transparent rounded-full" />
            <p className="text-xs text-gray-400 font-medium">Loading conversation...</p>
          </div>
        )
      ) : (
        <EmptyChatView />
      )}
    </div>
  );
};

export default ChatConsole;
